
import Axios from "./CallerService"
export const getThirdpartie = () => {
    return Axios.get(`thirdparties?limit=-1&mode=4`)
}
